<template>
<div class="ag" v-if="loaded">
  <agile
    class="main"
    ref="main"
    :options="mainOpts"
    >
    <div class="slide" v-for="(slide, index) in slides.main" :key="index" :class="`slide--${index}`">
      <img :src="slide" />
    </div>
  </agile>
  <agile
    class="thumbnails"
    ref="thumbnails"
    :options="thumbOpts"
    @after-change="$refs.main.goTo($refs.thumbnails.getCurrentSlide())"
    >
    <div class="slide slide--thumbnail" v-for="(slide, index) in slides.thumb"
         :key="index"
         :class="`slide--${index}`"
         @click="$refs.main.goTo(index) && $refs.thumbnails.goTo(index)">
      <img :src="slide" />
    </div>
    <!--
    <template slot="prevButton"><i class="fas fa-chevron-left"></i></template>
    <template slot="nextButton"><i class="fas fa-chevron-right"></i></template> -->
  </agile>
</div>
</template>

<script>

import {
  apiCampaignDetail,
} from "@/api/campaigns.js";

import { VueAgile } from "vue-agile";
import { mapGetters } from "vuex";

export default {
  name: 'CampaignImages',
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    }),
    loaded: function () {
      return this.slides.main.length >= 1;
    }
  },
  data() {
    return {
      campaignIdent: this.$parent.campaignIdent,
      campaign: {},
      speed: 5000,
      mainOpts: {
        dots: false,
        fade: true,
        navButtons: false,
      },
      thumbOpts: {
        centerMode: true,
        dots: false,
        navButtons: true,
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        responsive: [
          {breakpoint: 600,
           settings: {
             slidesToShow: 4,
           }
          }
        ]
      },
      slides: {
        thumb: [],
        main: []
      }
    };
  },
  async created() {
    await this.fetchData();
    this.slides.main.push(this.genAssetURI(this.campaign.images.primary.src));
    this.slides.thumb.push(this.genAssetURI(this.campaign.images.primary.src, 'evtw-c-v-t'));
    this.campaign.images.gallery.forEach( el => {
      this.slides.main.push(this.genAssetURI(el.src));
      this.slides.thumb.push(this.genAssetURI(el.src, 'evtw-c-v-t'));
    });
  },
  methods: {
    async fetchData() {
      const rv = await apiCampaignDetail(this.$userClient, this.campaignIdent);
      if (rv) {
        this.campaign = rv.campaign;
      }
    },
    genAssetURI( template, format) {
      let defaultFormat;
      if (document.querySelector('html').clientWidth > 480) {
        defaultFormat = 'evtw-c-v';
      } else {
        defaultFormat = 'evtw-c-v-m';
      }
      const fmt = format ? format : defaultFormat;
      return template.replace('{FORMAT}', fmt);
    }
  },
  components: {
    agile: VueAgile
  }
}
</script>

<style scoped>
.ag {
    font-family: 'Lato', sans-serif;
    font-weight: 300;
    margin: 0 auto;
    max-width: 600px;
    padding: 0px;
}
.main {
  margin-bottom: 5px;
}

.thumbnails {
  height: 100px;
  margin: 0 -5px;
  width: calc(100% + 10px);
}
.agile__nav-button {
  background: transparent;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 24px;
  -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
}
.thumbnails .agile__nav-button {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}
.thumbnails .agile__nav-button--prev {
  left: -45px;
}
.thumbnails .agile__nav-button--next {
  right: -45px;
}
.agile__nav-button:hover {
  color: #888;
}
.agile__dot {
  margin: 0 10px;
}
.agile__dot button {
  background-color: #eee;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
  width: 10px;
}
.agile__dot--current button, .agile__dot:hover button {
  background-color: #888;
}
.slide {
  -webkit-box-align: center;
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: -webkit-box;
  display: flex;
  /*height: 400px;*/
  -webkit-box-pack: center;
  justify-content: center;
}
.slide--thumbnail {
  cursor: pointer;
  height: 80px;
  padding: 0 5px;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}
.slide--thumbnail:hover {
  opacity: 0.75;
}
.slide img {
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
  width: 100%;
}
.slide--thumbnail img {
    width: 120px;
}
</style>
